import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  item: {
    backgroundColor: theme.colorPalette.beige_50,
    width: '100%',
    borderRadius: theme.sizes.roundCorners
  },
  itemTitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 4)
  },
  itemName: {
    fontSize: 14,
    fontWeight: 400,
    margin: '0 0 4px 0',
    color: theme.colorPalette.green_80,
    flexGrow: 1
  },
  itemType: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.green_75,
    textTransform: 'uppercase'
  },
  itemStack: {
    display: 'flex',
    flexDirection: 'column'
  },
  itemLabel: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.green_75,
    textTransform: 'uppercase'
  },
  itemValue: {
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colorPalette.green_80
  },
  divider: {
    width: '1px',
    height: '34px',
    backgroundColor: theme.colorPalette.green_75,
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_60 })
  },
  deleteButton: {
    color: theme.colorPalette.orange_75,
    ...reskinStyles(theme, { color: theme.colors.action_text }),
    '& img': {
      height: 24,
      width: 24
    }
  },
  expandIcon: {
    color: theme.colors.action_text,
    marginLeft: theme.spacing(2),
    '& img': {
      height: 24,
      width: 24
    }
  },
  iconFold: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform 200ms'
  },
  icon: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform 200ms',
    transform: 'rotate(180deg)'
  },
  formContainer: {
    borderTop: `1px solid ${theme.onCardDivider.white}`,
    padding: theme.spacing(4),
    backgroundColor: theme.colorPalette.beige_50
  },
  sectionFooter: {
    marginTop: theme.spacing(2)
  },
  livestockInfoTextContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    '& svg': {
      marginRight: theme.spacing(2)
    }
  },
  livestockInfoText: {
    fontSize: '12px',
    color: theme.colorPalette.green_100
  }
}));

export default useStyles;
